export default "__VITE_ASSET__CriK3$G8__"